import { ChatEmojiService } from '@agent/agent-interface/contact-view/chat/services/chat-emoji.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'chat-emoji',
  templateUrl: 'chat-emoji.component.html',
  styleUrls: ['./chat-emoji.component.scss'],
})
export class ChatEmojiComponent implements OnInit {
  @Output()
  onEmojiSelect: EventEmitter<any> = new EventEmitter();

  emojiList: Array<string> = [];

  constructor(private readonly emojiService: ChatEmojiService) {}

  ngOnInit() {
    this.emojiList.push(
      'sunny',
      'cloud',
      'hushed',
      'pensive',
      'thinking_face',
      'sunglasses',
      'grinning',
      '+1',
      'wink',
      'slightly_smiling_face'
    );
  }

  getEmoji(e: string) {
    return this.emojiService.getEmoji(e);
  }

  clickEmoji(emoji) {
    this.onEmojiSelect.emit(this.getEmoji(emoji));
  }
}
